export default __webpack_public_path__ + "static/media/33.d6ec95d6.png";